import { Text } from 'blaze-ui/Text/Text'
import { UnlockButton } from 'blaze-components/WriterTopBar/UnlockButton'
import { MobileTopBarContainer } from 'blaze-components/MobileTopBarContainer'
import { ExternalIntegrationSelect } from 'screens/Analytics/components/ExternalIntegrationSelect/ExternalIntegrationSelect'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import useURLParams from 'hooks/useURLParams'
import { ANALYTICS_SUPPORTED_PROVIDERS } from 'screens/Analytics/Analytics'
import { useHeaderTheme } from 'hooks/useHeaderTheme'
import { SearchButton } from 'blaze-components/WriterTopBar/SearchButton'

export const AnalyticsMobileTopBar = () => {
  const theme = useHeaderTheme()
  const { data } = useExternalIntegrations()
  const [searchParams, setSearchParams] = useURLParams()

  const supportedIntegrations =
    data?.external_integrations.filter((integration) =>
      ANALYTICS_SUPPORTED_PROVIDERS.includes(integration.provider as never),
    ) || []

  const selectedIntegrationId = searchParams.get('external_integration_id')

  if (!selectedIntegrationId && supportedIntegrations.length > 0) {
    setSearchParams({ external_integration_id: supportedIntegrations[0].id.toString() })
  }

  return (
    <MobileTopBarContainer.Root data-theme={theme}>
      <MobileTopBarContainer.Left>
        <UnlockButton />
        <SearchButton />
      </MobileTopBarContainer.Left>
      <MobileTopBarContainer.Center>
        <Text>Content Analytics</Text>
      </MobileTopBarContainer.Center>
      <MobileTopBarContainer.Right>
        <ExternalIntegrationSelect
          variant="ghost"
          selectedExternalIntegrationId={parseInt(selectedIntegrationId || '')}
          externalIntegrations={supportedIntegrations}
          onChange={(id) => setSearchParams({ external_integration_id: id.toString() })}
        />
      </MobileTopBarContainer.Right>
    </MobileTopBarContainer.Root>
  )
}
